require('./tags.less')
require('../../app/app');

var i18n = require('i18n');
var pageConfig = window.pageConfig || {};
var pagination = require('../../app/pagination');
var topicList = require('../../app/topicList.html');
pageConfig.adStr = pageConfig.admin ? i18n('admin') : pageConfig.plateAd ? i18n('plate.admin') : '';




var App = {
  init: function() {
  	if (pageConfig.error) {
  		util.show(pageConfig.error, 'error');
  		return;
  	}
  	
  	pageConfig.login = !!window.pageConfig.user.id;
  	var wrapper = require('../../app/main.html');
		$('body').append(wrapper(window.pageConfig));


		var tag = location.pathname.match(/tags\/([^?#]+)/)[1];

		$('.list-title').text(decodeURIComponent(tag) + ':');
    var userAgent = window.navigator.userAgent || '';
    if (userAgent.match(/[bB]ot\//)  || userAgent.match('[sS]pider')) {
      return
    }
		pagination(`${pageConfig.projectName}/topic/tagList?tag=${tag}`, topicList);
  }
}

// Entry
;(function() {
  App.init();
})();


// WEBPACK FOOTER //
// ./src/pages/tags/tags.js